import router from '@/router'
import adminAuthHeader from '@/helpers/adminAuthHeader'

// Same call-chain pattern as helpers/api.js, but scoped to the Factory Tour /
// Blog admin panel: on 401 it clears the admin token and redirects to
// /admin/login instead of the public site's /login.
export default (context, service) => {
    let api = {
        default: {
            // eslint-disable-next-line no-unused-vars
            onSuccess(response) {

            },
            // eslint-disable-next-line no-unused-vars
            onError(error) {

            },
            onFinish() {

            },
        },
        onSuccess(handler) {
            api.successHandling = handler
            return api;
        },
        onError(handler) {
            api.errorHandling = handler
            return api;
        },
        onFinish(handler) {
            api.finishHandling = handler
            return api;
        },
        successHandling: function(response) {
            api.default.onSuccess(response)
        },
        errorHandling: function(error) {
            api.default.onError(error)
        },
        finishHandling: function() {
            api.default.onFinish()
        },
        call: function() {
            service.then(response => {
                api.successHandling(response)
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    adminAuthHeader.unset();
                    router.push('/admin/login');
                }
                api.errorHandling(error)
            }).then(() => {
                api.finishHandling()
            })
        }
    }
    return api
}
